/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { GridContainer, TargetDescription, EstimatedIr } from './Components';
import { allTypes } from './types';
import { Naming } from './Naming';


export default class Form extends React.Component {
  constructor() {
    super();
    this.state = {
      products: allTypes,
      type: 'television ads',
      components: [],
      sampleSize: 150,
      countries: [{ value: 'NL', label: 'Netherlands' }],
    };
  }

  componentDidMount() {
    this.setState(
      {
        components: this.state.products[this.props.product],
        type: this.props.type,
      },
      () => {
        this.props.shareState(this.state);
      },
    );
  }

  handleChange = (input, component, index) => {
    const value = input.target ? input.target.value : input;
    if (
      index >= 0
      && component !== 'estimatedIr'
      && component !== 'targetDescription'
      && component !== 'sampleSize'
      && component !== 'campaignCreatives'
    ) {
      const copyArray = [...this.props[this.props.product].composition];
      copyArray[index] = value;
      const updateObject = { composition: copyArray };
      this.props.shareState(updateObject, this.props.product);
    } else if (index >= 0 && component === 'campaignCreatives') {
      const copyArray = [...this.props[this.props.product].campaignCreatives];
      copyArray[index] = value;
      const updateObject = { [component]: copyArray };
      this.props.shareState(updateObject, this.props.product);
    } else if (index >= 0 && component === 'sampleSize') {
      const copyArray = [...this.props[this.props.product].sampleSize];
      copyArray[index] = Number(value);
      const updateObject = { [component]: copyArray };

      this.props.shareState(updateObject, this.props.product);
    } else if (index >= 0) {
      const copyArray = [...this.props[this.props.product].composition];
      copyArray[index][component] = value;
      const updateObject = { composition: copyArray };
      this.props.shareState(updateObject, this.props.product);
    } else {
      const updateObject = { [component]: value };

      this.props.shareState(updateObject, this.props.product);
    }
  };

  render() {
    return (
      <div>
        <Naming
          handleChange={this.handleChange}
          title={this.props[this.props.product].title}
          objective={this.props[this.props.product].objective}
          filledInError={this.props.filledInError}
        />
        {this.props.product[0] !== 'customer-centricity-scan'
        && this.props.product[0] !== 'employee-engagement-scan' ? (
          <div>
            <section
              style={{
                textAlign: 'right',
                paddingBottom: '4px',
                color: '#AAAAAA',
              }}
            >
              SPECIFICATIONS
            </section>
            <hr />
          </div>
          ) : null}

        {this.state.components.map((val) => {
          // console.log('val: ', val);
          const { Component } = val;
          if (val.label === 'composition') {
            const compositions = Array.from(
              Array(parseInt(this.props[this.props.product].compNumber, 10)),
            ).map((item, i) => (
              <GridContainer key={val.label + i}>
                <Component
                  handleChange={this.handleChange}
                  index={i}
                  value={this.props[this.props.product][val.label][i]}
                  filledInError={this.props.filledInError}
                >
                  <TargetDescription
                    handleChange={this.handleChange}
                    index={i}
                    value={this.props[this.props.product][val.label][i]}
                    filledInError={this.props.filledInError[val.label]}
                  />
                  <EstimatedIr
                    handleChange={this.handleChange}
                    index={i}
                    value={this.props[this.props.product][val.label][i]}
                    filledInError={this.props.filledInError[val.label]}
                  />
                </Component>
              </GridContainer>
            ));
            return compositions;
          }
          if (val.label === 'uploadQuestionnaire') {
            return (
              <GridContainer key={val.label}>
                <Component
                  handleChange={this.handleChange}
                  handleSelectedFile={this.props.handleSelectedFile}
                  value={this.props[this.props.product][val.label]}
                  filledInError={this.props.filledInError}
                  type={this.props[this.props.product].type}
                />
              </GridContainer>
            );
          }
          return (
            <GridContainer key={val.label}>
              <Component
                handleChange={this.handleChange}
                value={this.props[this.props.product][val.label]}
                filledInError={this.props.filledInError}
                type={this.props[this.props.product].type}
              />
            </GridContainer>
          );
        })}
      </div>
    );
  }
}
